import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Textfield } from ".";
import { displayError, getCountryStates } from "../helpers";
import { fundRaiserPageAction } from "../store/actions";
import { Dropdown } from "./Dropdown";
export function AddressForm({ addressDetails, updateAddressDetails, validationErrors, name }) {
    let dispatch = useDispatch();
    const [countryOptions, setCountryOptions] = useState([]);
    const [countryStateOptions, setCountryStateOptions] = useState([]);
    const userInfoCountries = useSelector(state => state.countries.countries_without_partners)

    const mapCountries = () => {
        const countries = [];
        userInfoCountries.map(val => {
            countries.push({
                id: val.id,
                name: val.name,
                // country_code: val.code,
            })
        });
        return countries
    }

    const getAndMapCountryStates = async (countryId) => {
        const countryStates = await getCountryStates(countryId)
        const states = [];
        countryStates.map(state => {
            states.push({
                id: state.id,
                name: state.name,
                // country_code: state.code,
            })
        });
        setCountryStateOptions(states)
        return states;
    }

    useEffect(() => {
        dispatch(fundRaiserPageAction.getListOfCountriesWithoutPartners());
    }, [])

    useEffect(() => {
        if (addressDetails.country)
            getAndMapCountryStates(addressDetails.country)
    }, [addressDetails.country])
    useEffect(() => {
        if (userInfoCountries) {
            const countries = mapCountries();
            setCountryOptions(countries)
        }
    }, [userInfoCountries])

    return <Grid container rowGap={3} columnSpacing={'12px'} id="giftAidAddressForm">
        <Grid item xs={12} lg={6} md={6}>
            <Dropdown
                id="country"
                name={name}
                label="Select Country *"
                value={addressDetails?.country | ''}
                options={countryOptions}
                onChange={updateAddressDetails}
                error={displayError(validationErrors?.country)}
                helperText={validationErrors?.country}
                fullWidth
                disableClearable
                autoComplete="country-name"
            />
        </Grid>

        <Grid item xs={12} lg={6} md={6}>
            <Textfield
                name={name}
                id="city"
                label="City *"
                autoComplete="address-level2"
                value={addressDetails.city || ""}
                onChange={updateAddressDetails}
                error={displayError(validationErrors?.city)}
                helperText={validationErrors?.city}
                fullWidth
            />
        </Grid>

        <Grid item xs={12}>
            <Textfield
                name={name}
                id="address"
                label="Address *"
                autoComplete="street-address"
                value={addressDetails.address || ""}
                onChange={updateAddressDetails}
                error={displayError(validationErrors?.address)}
                helperText={validationErrors?.address}
                multiline
                rows={2}
                fullWidth
            />
        </Grid>

        <Grid item xs={12} lg={6} md={6}>
            <Dropdown
                id="countryState"
                name={name}
                label="Select State *"
                value={addressDetails?.countryState}
                options={countryStateOptions}
                onChange={updateAddressDetails}
                error={displayError(validationErrors?.countryState)}
                helperText={validationErrors?.countryState}
                fullWidth
                disableClearable
                autoComplete="address-level1"
            />
        </Grid>

        <Grid item xs={12} lg={6} md={6}>
            <Textfield
                name={name}
                id="zipCode"
                label="Zip/Postal Code *"
                autoComplete="postal-code"
                value={addressDetails.zipCode}
                onChange={updateAddressDetails}
                error={displayError(validationErrors?.zipCode)}
                helperText={validationErrors?.zipCode}
                fullWidth
            />
        </Grid>

    </Grid>
}